import { formatServerDate } from './helpers';
import { camelCaseKeys } from './object';

// Convert the backend's `date_filtering` payload into the form shape used by
// DateFilteringControl. The form holds `dateRange` as a tuple of Date objects
// so the existing DatePicker component can drive it directly. We use
// formatServerDate (the codebase convention — see mapContractToForm.ts and
// mapLineItemToForm.ts) so we get a local-midnight Date whose calendar day
// matches the server's, regardless of the timezone in the incoming string.
// See ADOPS-2553.
const hydrateDateFiltering = (dateFiltering) => {
  if (!dateFiltering || dateFiltering.enabled !== true) {
    return { enabled: false };
  }

  const [start, end] = dateFiltering.dateRange ?? [];
  if (start && end) {
    return {
      enabled: true,
      dateRange: [formatServerDate(start), formatServerDate(end)],
    };
  }

  if (dateFiltering.lookback) {
    return {
      enabled: true,
      lookback: {
        datePart: dateFiltering.lookback.datePart,
        length: dateFiltering.lookback.length ?? 0,
      },
    };
  }

  return { enabled: false };
};

const mapReportTemplateToForm = (reportTemplate, firstSheetId = 1000) => {
  let nextSheetId = firstSheetId;
  const form = camelCaseKeys(reportTemplate);
  return {
    ...form,
    dateFiltering: hydrateDateFiltering(form.dateFiltering),
    sheetObjects: form.sheetObjects.map((sheet) => {
      nextSheetId += 1;
      return {
        ...sheet,
        reportSections: sheet.reportSections?.map((reportSection, index) => ({
          ...reportSection,
          id: index + 1,
        })),
        id: nextSheetId,
      };
    }),
  };
};

export default mapReportTemplateToForm;
